var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.childrenLinks && _vm.isHeader ? _c('li', {
    class: {
      headerLink: true,
      className: _vm.className,
      collapsed: _vm.collapsed
    }
  }, [!_vm.link.includes('http') ? _c('router-link', {
    staticClass: "sidebar-link d-flex",
    attrs: {
      "to": _vm.link,
      "active-class": "router-link-active"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.closeAllMenus.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm.iconName ? _c('i', {
    class: _vm.fullIconName
  }) : _vm._e(), _vm.imgUrl ? _c('img', {
    attrs: {
      "src": _vm.imgUrl
    }
  }) : _vm._e()]), _vm.showHeader && !_vm.collapsed ? _c('span', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.header))]) : _vm._e(), _vm.label && !_vm.collapsed ? _c('sup', {
    staticClass: "headerLabel",
    class: 'text-' + _vm.labelColor
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm.badge && !_vm.collapsed ? _c('b-badge', {
    attrs: {
      "variant": "primary",
      "pill": ""
    }
  }, [_vm._v(_vm._s(_vm.badge))]) : _vm._e()], 1) : _vm._e(), _vm.link.includes('http') ? _c('a', {
    staticClass: "sidebar-link d-flex",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    },
    on: {
      "click": _vm.closeAllMenus
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm.iconName ? _c('i', {
    class: _vm.fullIconName
  }) : _vm._e(), _vm.imgUrl ? _c('img', {
    attrs: {
      "src": _vm.imgUrl
    }
  }) : _vm._e()]), _vm.showHeader && !_vm.collapsed ? _c('span', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.header))]) : _vm._e(), _vm.label && !_vm.collapsed ? _c('sup', {
    staticClass: "headerLabel",
    class: 'text-' + _vm.labelColor
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm.badge && !_vm.collapsed ? _c('b-badge', {
    attrs: {
      "variant": "primary",
      "pill": ""
    }
  }, [_vm._v(_vm._s(_vm.badge))]) : _vm._e()], 1) : _vm._e(), _vm.collapsed ? _c('div', {
    staticClass: "nav-tooltip"
  }, [_vm._v(_vm._s(_vm.header))]) : _vm._e()], 1) : _vm.childrenLinks ? _c('li', {
    class: {
      headerLink: true,
      className: _vm.className,
      collapsed: _vm.collapsed
    }
  }, [_c('div', {
    staticClass: "dropdown-toggle",
    on: {
      "click": function click($event) {
        return _vm.togglePanelCollapse(_vm.link);
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.link,
      "custom": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var navigate = _ref.navigate,
          routerActive = _ref.isActive,
          isExactActive = _ref.isExactActive;
        return [_c('a', {
          staticClass: "d-flex sidebar-link",
          class: {
            'router-link-active': routerActive,
            'router-link-exact-active': isExactActive
          },
          on: {
            "click": navigate
          }
        }, [_c('span', {
          staticClass: "icon"
        }, [_vm.iconName ? _c('i', {
          class: _vm.fullIconName
        }) : _vm._e(), _vm.imgUrl ? _c('img', {
          attrs: {
            "src": _vm.imgUrl
          }
        }) : _vm._e()]), _vm.showHeader && !_vm.collapsed ? _c('span', {
          staticClass: "header-text"
        }, [_vm._v(_vm._s(_vm.header))]) : _vm._e(), _vm.label && !_vm.collapsed ? _c('sup', {
          staticClass: "ml-1 headerLabel",
          class: 'text-' + _vm.labelColor
        }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), !_vm.collapsed ? _c('div', {
          class: {
            caretWrapper: true,
            carretActive: _vm.isActive
          }
        }, [_c('i', {
          staticClass: "fa fa-chevron-down"
        })]) : _vm._e()])];
      }
    }])
  }), _vm.collapsed ? _c('div', {
    staticClass: "nav-tooltip"
  }, [_vm._v(_vm._s(_vm.header))]) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "menu-collapse"
    }
  }, [!_vm.collapsed && _vm.isActive ? _c('div', {
    staticClass: "custom-collapse"
  }, [_c('ul', {
    staticClass: "sub-menu"
  }, _vm._l(_vm.childrenLinks, function (child) {
    return _c('li', {
      key: child.link,
      staticClass: "child-link"
    }, [!child.link.includes('http') ? _c('router-link', {
      staticClass: "child-link-item",
      attrs: {
        "to": child.link,
        "active-class": "router-link-active",
        "exact-active-class": "router-link-exact-active"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.closeAllMenus.apply(null, arguments);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(child.header))]), child.label ? _c('sup', {
      staticClass: "headerLabel",
      class: 'text-' + (child.labelColor || 'warning')
    }, [_vm._v(_vm._s(child.label))]) : _vm._e()]) : _c('a', {
      staticClass: "child-link-item",
      attrs: {
        "href": child.link,
        "target": "_blank"
      },
      on: {
        "click": _vm.closeAllMenus
      }
    }, [_c('span', [_vm._v(_vm._s(child.header))]), child.label ? _c('sup', {
      staticClass: "headerLabel",
      class: 'text-' + (child.labelColor || 'warning')
    }, [_vm._v(_vm._s(child.label))]) : _vm._e()])], 1);
  }), 0)]) : _vm._e()])], 1) : _c('li', {
    class: {
      collapsed: _vm.collapsed
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.index !== 'menu' && _vm.link,
      "active-class": "router-link-active",
      "exact-active-class": "router-link-exact-active"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.closeAllMenus.apply(null, arguments);
      }
    }
  }, [!_vm.collapsed ? _c('span', [_vm._v(_vm._s(_vm.header))]) : _vm._e(), _vm.label && !_vm.collapsed ? _c('sup', {
    staticClass: "headerLabel",
    class: 'text-' + _vm.labelColor
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]), _vm.collapsed ? _c('div', {
    staticClass: "nav-tooltip"
  }, [_vm._v(_vm._s(_vm.header))]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }